import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMapPin, FiFacebook, FiMail } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold text-yellow-400 mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-pink-400" />
                <span>+1 (905) 820-7700</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-pink-400" />
                <span>+1 (647) 537-0181 (WhatsApp)</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="text-pink-400" />
                <span>3700 Eglinton Ave W unit 56, Mississauga, ON L5M 2R9</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold text-yellow-400 mb-4">Quick Links</h3>
            <div className="space-y-2">
              <a href="#" className="block hover:text-yellow-400 transition-colors">Menu</a>
              <a href="#" className="block hover:text-yellow-400 transition-colors">About Us</a>
              <a href="#" className="block hover:text-yellow-400 transition-colors">Gallery</a>
              <a href="#" className="block hover:text-yellow-400 transition-colors">Reviews</a>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-xl font-bold text-yellow-400 mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/Zalabya.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl text-pink-400 hover:text-yellow-400 transition-colors"
              >
                <SafeIcon icon={FiFacebook} />
              </a>
            </div>
            <div className="mt-4">
              <p className="text-sm text-gray-400">
                Visit us at: <a href="https://zalabya.ca" className="text-yellow-400 hover:underline">zalabya.ca</a>
              </p>
            </div>
          </div>
        </motion.div>

        <hr className="border-gray-700 my-8" />

        <div className="text-center text-sm text-gray-400">
          <p>&copy; {currentYear} Zalabya. All rights reserved.</p>
          <p className="mt-2">
            Domain + Hosting + Design = <a href="https://www.account4web.ca" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:underline">Account4Web Inc</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;